module.exports = __webpack_public_path__ + "img/icon_chili.c44b7f6.png";